import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchHostnameDefaults, updateHostnameDefaults } from './api';

export function useHostnameDefaults(organizationId: string) {
  const client = useQueryClient();
  const queryKey = ['backoffice-hostname-defaults', organizationId];
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => fetchHostnameDefaults(organizationId, signal),
    staleTime: 30_000,
  });
  const update = useMutation({
    mutationFn: (defaults: { insights: string; customer_success: string }) =>
      updateHostnameDefaults(organizationId, defaults),
    onSuccess: (defaults) => {
      client.setQueryData(queryKey, defaults);
    },
  });
  return { ...query, update };
}
